import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

// POST /ajax/student/create
export const createStudent = async (
  studentInfo: TStudentInfo,
  familyAccountId: number,
  districtId: number
): Promise<any> => {
  return new Promise((resolve, reject) => {
    const req = new Request()
    req
      .post('/ajax/student/create', {
        student_info: studentInfo,
        family_account_id: familyAccountId,
        district_id: districtId
      })
      .then((response: any) => {
        resolve(response.student_account_id)
      })
      .catch((err: any) => {
        reject('Failed to create student: ' + err.responseText)
      })
  })
}
